/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { getContactFieldList } from '../config';
import { createUseStyles } from '../palette';
import decorate from '../common/utils/decorate';
import AddressInput from '../common/components/AddressInput';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Agreement from '../pages/Agreement';
import CartEmpty from '../pages/CartEmpty';
import Completion from '../pages/Completion';
import CreateOrder from '../pages/CreateOrder';
import PickupPoints from '../pages/PickupPoints';
import SelectAddress from '../pages/SelectAddress';
import SelectMethod from '../pages/SelectMethod';
import SelectPayment from '../pages/SelectPayment';
import UserContacts from '../pages/UserContacts';
import Card from '../ui/Card';
import Checkbox from '../ui/Checkbox';
import Grid from '../ui/Grid';
import Skeleton from '../ui/Skeleton';
import Text from '../ui/Text';

const useStyles = createUseStyles((theme) => ({
  container: {
    userSelect: 'none',

    position: 'relative',
    zIndex: 1
  }
}));

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;

    static decorateWith = {
      classes: useStyles
    };

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
      super(props);

      this.state = {
        page: 'select-address',
        agreement: null,
        paymentInfo: undefined
      };
    }

    onUpdateLocalityData = () => {
      const { onClearQuery } = this.props;

      onClearQuery(() => {
        this.setState((state) => {
          state = { ...state };

          if (state.page !== 'select-address' && state.page !== 'select-method')
            state.page = 'select-method';

          return state;
        });
      });
    };

    onAgreementShow = (agreement) => (event) => {
      const { langString } = this.context;

      event?.preventDefault();

      if (!agreement) {
        this.setState((state) => ({ ...state, agreement }));

        return;
      }

      const agreementLink = langString(agreement.link);
      const agreementContent = langString(agreement.content);

      if (agreementLink) {
        if (typeof window !== 'undefined') window.open(agreementLink);
      } else if (agreementContent) {
        this.setState((state) => ({ ...state, agreement }));

        this.context.scrollTop();
      }
    };

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {
      const { cart } = this.context;

      const cartCount = Array.isArray(cart?.list)
        ? cart.list.reduce(
            (result, item) => result + Number(item?.count || 0) || 0,
            0
          )
        : 0;

      if (
        this.lastCartCount !== cartCount ||
        this.props.currency !== prevProps.currency ||
        this.props.warehouse.id !== prevProps.warehouse.id ||
        AddressInput.buildValue('delivery', 'city', this.props.localityData) !==
          AddressInput.buildValue('delivery', 'city', prevProps.localityData)
      ) {
        this.lastCartCount = cartCount;

        this.onUpdateLocalityData();
      }
    }

    render() {
      const {
        classes,

        localityData,
        onLocalityData,

        service,
        method,
        onMethod,
        company,
        tariff,

        pickupPoint,
        onPickupPoint,

        address,
        onAddress,
        getAddressField,
        setAddressField,

        onNextPage,
        onPrevPage
      } = this.props;

      const {
        type,
        cart,
        documents,
        editor,

        scrollTop,

        serviceList,
        methodList,
        methodQuery,
        companyList,
        tariffList,

        isSmall,
        isLangsLoading
      } = this.context;

      if (isLangsLoading) {
        return (
          <Grid container>
            <Grid>
              <Card>
                <Card variant="bordered">
                  <Checkbox disabled variant="radio">
                    <Text strong>
                      <Skeleton />
                    </Text>
                    <Text size="sm">
                      <Skeleton />
                    </Text>
                    <Text size="sm">
                      <Skeleton />
                    </Text>
                  </Checkbox>
                </Card>
              </Card>
            </Grid>
          </Grid>
        );
      }

      if (type === 'delivery') {
        if (editor && this.state.page === 'select-address')
          this.state.page = 'select-method';

        if (
          !service &&
          serviceList &&
          methodList &&
          companyList &&
          tariffList
        ) {
          if (editor) {
            if (editor.service) {
              const service = serviceList.find((item) => item.id === editor.service);
              const method = methodList.find((item) => item.id === editor.method);
              const company = companyList.find((item) => item.id === editor.company);
              const tariff = tariffList.find((item) => item.id === editor.tariff);

              if (service && method && company && tariff)
                setTimeout(() => onMethod(service, method, company, tariff), 1);
            }
          }
        }
      } else if (type === 'payment') {
        if (this.state.page === 'select-address')
          this.state.page = 'select-payment';
      }

      return (
        <div className={classes.container}>
          {this.state.agreement ? (
            <Agreement
              agreement={this.state.agreement}
              onPrevPage={this.onAgreementShow(null)}
            />
          ) : cart?.list?.length && this.state.page === 'select-address' ? (
            <SelectAddress
              address={address}
              onNextPage={(saved, address) => {
                scrollTop();

                this.setState((state) => ({
                  ...state,

                  page: saved ? 'user-contacts' : 'select-method',
                  isSavedAddress: saved
                }));

                onAddress(address);
              }}
              onPrevPage={() => {
                scrollTop();
                onPrevPage();
              }}
            />
          ) : cart?.list?.length && this.state.page === 'select-method' ? (
            <SelectMethod
              localityData={localityData}
              onLocalityData={onLocalityData}
              method={method?.id}
              onMethod={(methodId) => {
                const method = methodList?.find((item) => item.id === methodId);
                
                if (!method) return;
                
                const queryCompanies = methodQuery[method.id]?.companies;
                
                const company = queryCompanies && companyList?.find((item) => queryCompanies.find((query) => query.id === item.id));
                
                const tariffQuery = company && methodQuery[method.id]?.tariffs.find((item) => item.company === company.id);
                
                const tariff = tariffQuery && tariffList?.find((item) => item.company === company.id && item.id === tariffQuery.id);
                
                if (!tariff) return;
                
                onMethod(tariff.service, method, company, tariff);
              }}
              company={company?.id}
              onCompany={(companyId) => {
                const company = companyList?.find((item) => item.id === companyId);
                
                const tariffQuery = company && methodQuery[method.id]?.tariffs.find((item) => item.company === company.id);
                
                const tariff = tariffQuery && tariffList?.find((item) => item.company === company.id && item.id === tariffQuery.id);
                
                if (!tariff) return;
                
                onMethod(tariff.service, method, company, tariff);
              }}
              tariff={tariff?.id}
              onTariff={(tariffId) => {
                const tariff = tariffList?.find((item) => item.id === tariffId);
                const company = tariff && companyList?.find((item) => item.id === tariff.company);
                
                if (!company) return;
                
                onMethod(tariff.service, method, company, tariff);
              }}
              onNextPage={() => {
                scrollTop();
                this.setState((state) => ({
                  ...state,
                  
                  page: method?.code === 'pickup' ? 'pickup-points' : 'user-contacts'
                }));
              }}
              onPrevPage={() => {
                scrollTop();
                
                if (editor) {
                  onPrevPage();
                  
                  return;
                }
                
                this.setState((state) => ({
                  ...state,
                  
                  page: 'select-address'
                }));
              }}
            />
          ) : cart?.list?.length && this.state.page === 'pickup-points' ? (
            <PickupPoints
              selectedPoint={pickupPoint}
              onSelectPoint={onPickupPoint}
              onNextPage={() => {
                scrollTop();
                this.setState((state) => ({ ...state, page: 'user-contacts' }));
              }}
              onPrevPage={() => {
                scrollTop();
                this.setState((state) => ({ ...state, page: 'select-method' }));
              }}
            />
          ) : cart?.list?.length && this.state.page === 'user-contacts' ? (
            <UserContacts
              isSavedAddress={this.state.isSavedAddress}
              getAddressField={getAddressField}
              setAddressField={setAddressField}
              onAgreementShow={this.onAgreementShow}
              onNextPage={() => {
                scrollTop();

                this.setState((state) => ({ ...state, page: 'create-order' }));
              }}
              onPrevPage={() => {
                scrollTop();
                this.setState((state) => ({
                  ...state,
                  page: this.state.isSavedAddress
                    ? 'select-address'
                    : method?.code === 'pickup'
                    ? 'pickup-points'
                    : 'select-method'
                }));
              }}
            />
          ) : cart?.list?.length && this.state.page === 'create-order' ? (
            <CreateOrder
              onNextPage={(order) => {
                scrollTop();

                if (onNextPage) {
                  onNextPage(order);
                } else {
                  this.setState((state) => ({ ...state, page: 'completion' }));
                }
              }}
              onPrevPage={(error) => {
                scrollTop();
                error
                  ? onPrevPage(error)
                  : this.setState((state) => ({
                      ...state,
                      page: 'user-contacts'
                    }));
              }}
            />
          ) : documents?.length && this.state.page === 'select-payment' ? (
            <SelectPayment
              paymentInfo={this.state.paymentInfo}
              setPaymentInfo={(callback) =>
                this.setState((state) => ({
                  ...state,
                  paymentInfo: callback(state.paymentInfo)
                }))
              }
              onAgreementShow={this.onAgreementShow}
              onNextPage={(request) => {
                scrollTop();
                onNextPage(request);
              }}
              onPrevPage={(error) => {
                scrollTop();
                onPrevPage(error);
              }}
            />
          ) : this.state.page === 'completion' ? (
            <Completion />
          ) : (
            <CartEmpty
              onPrevPage={() => {
                scrollTop();
                onPrevPage();
              }}
            />
          )}
        </div>
      );
    }
  }
);
